// http://kazupon.github.io/vue-i18n/en/messages.html

const requireLang = require.context(
  '@/lang',
  true,
  /\.json$/,
);

const messages = {};
interface Dict { [key: string]: string; }

for (const file of requireLang.keys()) {
  if (file === './index.ts') { continue; }

  const path = file.replace(/(\.\/|\.json$)/g, '').split('/');

  path.reduce((o: Dict = {}, s, i) => {
    if (o[s]) { return o[s]; }

    o[s] = i + 1 === path.length
      ? requireLang(file)
      : {};

    return o[s];
  }, messages);
}

export default messages;
